<template>
  <Set class="SetSpec" :class="specClass" :label="label">
    <slot />
  </Set>
</template>

<script>
import { getters } from '@utils'
import sift from 'sift'

export default {
  props: {
    label: String,
    laptop: Object,
    specKey: String,
  },
  computed: {
    specClass() {
      const specQueries = {
        price: ['priceNullish'],
        cpu: ['cpuNullish'],
        gpu: ['gpuNullish'],
        storage: ['ssdHddAmountNullish', 'ssdHddAmountLow'],
        memory: ['memoryAmountNullish', 'memoryAmountLow'],
        // ports: ['portsNullish'],
        weight: ['weightNullish', 'weightSmall'],
      }

      const specCurrent = specQueries[this.specKey]

      if (!specCurrent) return ''

      const getQueriesByKeys = (keys) => keys
        .map(key => (this.laptopsQueries
          .find(item => item.key === key) || {}).query)

      return getSpecClass(this.laptop, ...getQueriesByKeys(specCurrent))
    },
    ...getters('laptopsQueries'),
  },
}
const getSpecClass = (laptop, nullishQuery, improperQuery) => {
  if (nullishQuery && sift({ $or: nullishQuery })(laptop)) {
    return 'missing'
  }

  if (improperQuery && sift({ $or: improperQuery })(laptop)) {
    return 'improper'
  }
}
</script>

<style lang="scss">
.SetSpec {
  &.missing {
    background-color: $danger-lighter;
    min-height: 1rem;
  }

  &.improper {
    background-color: $warning-light;
    min-height: 1rem;
  }
}
</style>
